import { exportSheetToExcel, exportSheetToPDF, safeFilePart } from './sheetExport';
import { formatISODate } from './dates';

// Same palette as the on-screen COSECHA sheet (SalesFormPage.css).
const HEADER_ORANGE = 'ED7D31';
const MANUAL_GREEN = 'E2F0D9';
const OBSERVATION_GREEN = '92D050';

function formatWeight(value) {
  return String(Number(value)).replace('.', ',');
}

// Rows in the exact order of the Formulario de Ventas.
export function salesSheet(sale) {
  return {
    name: 'Cosecha',
    fileBase: `Cosecha_${safeFilePart(sale.farm_name, 'venta')}_${sale.date}`,
    header: 'COSECHA',
    headerColor: HEADER_ORANGE,
    rows: [
      { label: 'FECHA', text: formatISODate(sale.date), date: sale.date },
      { label: 'SEMANA', text: String(sale.week), number: sale.week },
      { label: 'DIA', text: sale.day },
      { label: 'EMPRESA', text: sale.company_name },
      { label: 'HACIENDA', text: sale.farm_name },
      { label: 'CODIGO MAGAP', text: sale.magap || '' },
      { label: 'EXPORTADORA', text: sale.exporter_name },
      { label: 'MARCA DE LA CAJA', text: sale.brand_name },
      { label: 'TIPO DE CAJA', text: sale.box_type_name || '' },
      { label: 'TRANSPORTE', text: sale.transportation_name },
      { label: 'CANTIDAD DE CAJAS', text: String(sale.boxes), number: sale.boxes, fill: MANUAL_GREEN },
      { label: 'PALLETS', text: String(sale.pallets), number: sale.pallets, fill: MANUAL_GREEN },
      {
        label: 'PESO CAJA FRUTA', text: formatWeight(sale.fruit_weight), number: Number(sale.fruit_weight),
        decimal: true, fill: MANUAL_GREEN,
      },
    ],
    banner: { text: `OBSERVACIÓN: ${sale.comment || ''}`.trim(), fill: OBSERVATION_GREEN },
  };
}

export function exportSaleToExcel(sale) {
  return exportSheetToExcel(salesSheet(sale));
}

export function exportSaleToPDF(sale) {
  exportSheetToPDF(salesSheet(sale));
}
